import React from "react";
import { Phone, Mail } from "lucide-react";
import { Link } from "react-router-dom";
import Logo from "../../assets/Logo.png";

const MobileTopHeader = () => {
  return (
    <header className="sticky top-0 z-50 bg-white border-b border-gray-200 shadow-xs">
      {/* Top Utility Contact Strip */}
      <div className="bg-[#1c1d1f] text-gray-300 px-3 py-1 flex items-center justify-between text-[11px]">
        <a
          href="tel:04023353898"
          className="flex items-center gap-1 hover:text-white transition-colors"
        >
          <Phone className="w-3 h-3 text-amber-500" />
          <span>+91 7434905789</span>
        </a>
        <a
          href="mailto:info@auriceng.in"
          className="flex items-center gap-1 hover:text-white transition-colors"
        >
          <Mail className="w-3 h-3 text-amber-500" />
          <span>info@auriceng.in</span>
        </a>
      </div>

      {/* Main Mobile App Bar */}
      <div className="px-3 py-2 flex items-center justify-between gap-3">
        {/* Logo */}
        <Link to="/" className="flex items-center">
          <img
            src={Logo}
            alt="Auric Engineering"
            style={{ height: "38px", maxHeight: "38px", maxWidth: "140px", objectFit: "contain" }}
          />
        </Link>

        {/* Polished Contact Action */}
        <Link
          to="/contact-us"
          className="inline-flex items-center gap-1.5 px-3.5 py-1.5 rounded-full bg-[#12385a] hover:bg-[#0c243b] active:scale-95 text-white text-xs font-semibold tracking-wide transition-all shadow-xs"
        >
          <Phone className="w-3 h-3 text-amber-400" />
          <span>Contact Us</span>
        </Link>
      </div>
    </header>
  );
};

export default MobileTopHeader;
